export const users: TableModule = {
    name: "users",
    route: "spa.settings.users",
    defaultOrder: {
        column: "lastname|firstname",
        direction: "asc"
    },
    columns: [
        {
            name: "customName",
            sortable: true,
            pageLink: true,
            sortBy: "lastname|firstname",
            mobile: true,
            width: "w-1/2 sm:w-auto"
        },
        {
            name: "email",
            sortable: true
        },
        {
            name: "role_name",
            sortable: true,
            mobile: true
        },
        {
            name: "created_at",
            sortable: true,
            breakpoint: "md"
        }
    ],
    filters: [
        {
            name: "id",
            column: "users.id",
            type: "numeric",
            reduced: '[,]'
        },
        {
            name: "firstname",
            column: "users.firstname",
            type: "string"
        },
        {
            name: "email",
            column: "users.email",
            type: "string",
            reduced: 'like'
        },
        {
            name: "organisation",
            column: "users.organisation_id",
            type: "select",
            options: () => $lara.get(
                useNuxtApp().$apiRoute('spa.settings.organisations.index')
            ).then(response => response.data?.map(
                organisation => ({
                    value: organisation.id,
                    label: organisation.name
                }))
            ),
            reduced: true,
            multiple: true
        },
        {
            name: "role",
            column: "users.role_name",
            type: "select",
            options: [
                {
                    value: "admin",
                    label: "users.roles.admin"
                },
                {
                    value: "user",
                    label: "users.roles.user"
                }
            ],
            reduced: true
        }
    ],
    quickFilters: [
        {
            name: "qf_onlyEmployees",
            column: "users.role_name",
            value: [
                "user"
            ],
            operator: "in"
        }
    ],
    tools: [
        {
            name: "users.delete",
            color: "rose",
            icon: "heroicons:trash"
        },
        {
            name: "users.create",
            isCreateAction: true,
            ability: [
                "create",
                "users"
            ]
        }
    ]
}